import React, { useState, useEffect } from 'react'
import { Row, Col, Typography, Button } from 'antd'
import AliceCarousel from 'react-alice-carousel'
import { HeaderHero, SEO } from './components'
import { ROADSIDE_ASSISTANCE_BREAK_POINTS, ROADSIDE_ASSISTANCE_ARRAY } from '../constants'
import { useWindowSize } from '../utils'
import PropTypes from 'prop-types'

import PartnerWithUsStyle from '../../styles/PartnerWithUs.module.css'
import AgencyApplyButton from './AgencyApplyButton'

const tabletImage = 'PartnerWithUsHeaderImage_1024x300.jpeg'
const desktopImage = 'PartnerWithUsHeaderImage_1440x300.jpeg'
const largeScreenImage = 'PartnerWithUsHeaderImage_1620x300.jpeg'
const xtraLargeScreenImage = 'PartnerWithUsHeaderImage_1960x300.jpeg'
const smallImage = 'PartnerWithUsHeaderImage_375x188.jpeg'
const smallImage390 = 'PartnerWithUsHeaderImage_390x188.jpeg'
const mobileImage = 'PartnerWithUsHeaderImage_428x188.jpeg'
const mobileImage768 = 'PartnerWithUsHeaderImage_768x300.jpeg'

const { Link, Text, Title } = Typography

const PartnerWithUsContent = ({ state }) => {
  //const [selectedState, setSelectedState] = useState("")
  const windowSize = useWindowSize()
  const [showMore, setShowMore] = useState(false)

  const listContent = (() => {
    if (state === "MI" || state === "NJ") {
      return {
        leftCol: [
          { item: "Competitive Commissions for long term growth", subItems: [] },
          { item: "Dedicated Agency Support Team", subItems: ["Comprehensive 2-hour live kickoff training via Zoom", "Support Center with guides and videos on-demand", "Agency Live Chat: Monday - Friday 8:30am - 5pm"] },
          { item: "POS system with Agency Sweep and streamlined commissions via EFT", subItems: [] },
          { item: "Comparative Raters - PL Rater(R) and EZLynx(R)", subItems: [] },
        ],
        rightCol: [
          { item: "Competitive discounts and pricing", subItems: ["Quotes provided without a credit check", "Rates not impacted by education or occupation", "No penalty if currently uninsured"] },
          { item: "CURE Mobile App for easy, on-the-go account access", subItems: [] },
          { item: "Customer Live Chat with Text options", subItems: [] },
          { item: "Online Quick Service Center", subItems: [] },
        ],
        showMore: [
          { item: "24/7 Roadside Assistance included with all policies", subItems: [] },
          { item: "24/7 claim reporting online and via Mobile App", subItems: [] },
          { item: "Friends and Family Referral Program", subItems: [] },
          { item: "Pre-approved direct repair facilities", subItems: [] },
        ]
      }
    }
    else if (state === "PA") {
      return {
        leftCol: [
          { item: "Competitive Commissions for long term growth", subItems: [] },
          { item: "Dedicated Agency Support Team", subItems: ["Comprehensive 2-hour live kickoff training via Zoom", "Support Center with guides and videos on-demand", "Agency Live Chat: Monday - Friday 8:30am - 5pm"] },
          { item: "POS system with Agency Sweep and streamlined commissions via EFT", subItems: [] },
        ],
        rightCol: [
          { item: "Competitive discounts and pricing", subItems: ["Quotes provided without a credit check", "Rates not impacted by education or occupation"] },
          { item: "CURE Mobile App for easy, on-the-go account access", subItems: [] },
          { item: "Customer Live Chat with Text options", subItems: [] },
          { item: "Online Quick Service Center", subItems: [] },
        ],
        showMore: [
          { item: "24/7 Roadside Assistance included with all policies", subItems: [] },
          { item: "24/7 claim reporting online and via Mobile App", subItems: [] },
          { item: "Pre-approved direct repair facilities", subItems: [] },
        ]
      }
    }
    else if (state === "FL") {
      return {
        leftCol: [
          { item: "Competitive Commissions for long term growth", subItems: [] },
          { item: "Dedicated Agency Support Team", subItems: ["Comprehensive 2-hour live kickoff training via Zoom", "Support Center with guides and videos on-demand", "Agency Live Chat: Monday - Friday 8:30am - 5pm"] },
          { item: "POS system with Agency Sweep and streamlined commissions via EFT", subItems: [] },
        ],
        rightCol: [
          { item: "Competitive discounts and pricing", subItems: ["Quotes provided without a credit check", "Rates not impacted by education or occupation"] },
          { item: "CURE Mobile App for easy, on-the-go account access", subItems: [] },
          { item: "Customer Live Chat with Text options", subItems: [] },
          { item: "Online Quick Service Center", subItems: [] },
          { item: "24/7 Roadside Assistance included with all policies", subItems: [] },
          { item: "24/7 claim reporting online and via Mobile App", subItems: [] },
        ],
        showMore: []
      }
    }
  })();

  const getFullState = (state) => {
    if (state === "PA") {
      return "Pennsylvania"
    }
    else if (state === "MI") {
      return "Michigan"
    }
    else if (state === "NJ") {
      return "New Jersey"
    }
    else if (state === "FL") {
      return "Florida"
    }
  }

  const isMobile = windowSize.width > 1024
  var descriptionFull = "Interested in becoming a CURE agent? Learn more about the CURE Agency Program and apply to be an appointed agent in Michigan, New Jersey, Pennsylvania, and Florida. "
  var urlName = "/PartnerWithUs";
  var titleName = "Partner With Us | CURE Auto Insurance";

  switch (state) {
    case "PA":
      urlName = "/PartnerWithUs/pa";
      break;
    case "MI":
      urlName = "/PartnerWithUs/mi";
      break;
    case "NJ":
      urlName = "/PartnerWithUs/nj";
      break;
    case "FL":
      urlName = "/PartnerWithUs/fl";
      break;
    default:
      break;
  }
  
  const MoreButton = () => {
    return (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px'
        }}
      >
        <Button className={`${PartnerWithUsStyle["more-button"]}`} disabled={showMore} onClick={() => setShowMore(true)}>
          MORE
        </Button>
        <Button
          className={`${PartnerWithUsStyle["more-button"]}`}
          style={{ marginLeft: "8px" }}
          disabled={!showMore}
          onClick={() => setShowMore(false)}
        >
          LESS
        </Button>
      </div>
    )
  }

  return (
    <>
      <SEO
        description={descriptionFull}
        title={titleName}
        url={urlName}
      />
      <HeaderHero
        desktopImage={desktopImage}
        largeScreenImage={largeScreenImage}
        mobileImage={mobileImage}
        mobileImage768={mobileImage768}
        smallImage={smallImage}
        smallImage390={smallImage390}
        tabletImage={tabletImage}
        xtraLargeScreenImage={xtraLargeScreenImage}
      />
      <div className={`${PartnerWithUsStyle["partner-with-us-screen"]}`}>
        <Col lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xl={{ span: 24 }} xs={{ span: 24 }}>
          <section>
            <Row justify="center">
              <Col className={`${PartnerWithUsStyle["subtitle-container"]}`}>
                <Text className={`${PartnerWithUsStyle["title"]}`}>
                  {getFullState(state)} Agency Program
                </Text>
              </Col>
            </Row>
            <Row justify="center" style={{ maxWidth: "1080px", margin: "auto" }}>
              <Col xl={{ span: 10 }} lg={{ span: 10 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center", maxWidth: "500px" }}>
                <div className={`${PartnerWithUsStyle["subtitle-container"]}`} style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", paddingTop: "8px", paddingBottom: "8px" }}>
                  <Text className={`${PartnerWithUsStyle["small-subtitle"]}`}>
                    Benefits for CURE Agencies
                  </Text>
                </div>
                <div>
                  <ul className={`${PartnerWithUsStyle["list"]} ${PartnerWithUsStyle["body"]}`}>
                    {listContent.leftCol.map((content, index) => (
                      <li key={index}>
                        {content.item}
                        {content.subItems.length > 0 && (
                          <ul>
                            {content.subItems.map((subItem, subIndex) => (
                              <li key={subIndex}>{subItem}</li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
              <Col xl={{ span: 4 }} lg={{ span: 4 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <Row justify="center" style={{ height: "100%" }}>
                  <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 0 }} sm={{ span: 0 }} xs={{ span: 0 }} style={{ height: "100%" }}>
                    <div style={{ display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                      <div style={{ height: "100%", backgroundColor: "rgb(29, 76, 128)", width: "4px" }} />
                    </div>
                  </Col>
                  <Col xl={{ span: 0 }} lg={{ span: 0 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ minHeight: "40px", }}>
                    <div style={{ display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                      <div style={{ height: "4px", backgroundColor: "rgb(29, 76, 128)", width: "40%" }} />
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xl={{ span: 10 }} lg={{ span: 10 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center", maxWidth: "500px" }}>
                <div className={`${PartnerWithUsStyle["subtitle-container"]}`} style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", paddingTop: "8px", paddingBottom: "8px" }}>
                  <Text className={`${PartnerWithUsStyle["small-subtitle"]}`}>
                    Benefits for Policyholders
                  </Text>
                </div>
                <div>
                  <ul className={`${PartnerWithUsStyle["list"]} ${PartnerWithUsStyle["body"]}`}>
                    {listContent.rightCol.map((content, index) => (
                      <li key={index}>
                        {content.item}
                        {content.subItems.length > 0 && (
                          <ul>
                            {content.subItems.map((subItem, subIndex) => (
                              <li key={subIndex}>{subItem}</li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                    {showMore && listContent.showMore.length > 0 && listContent.showMore.map((content, index) => (
                      <li key={index}>
                        {content.item}
                        {content.subItems.length > 0 && (
                          <ul>
                            {content.subItems.map((subItem, subIndex) => (
                              <li key={subIndex}>{subItem}</li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
                {listContent.showMore.length > 0 && <MoreButton />}
              </Col>
            </Row>
          </section>
          <section>
            <Row justify="center">
              <AgencyApplyButton link={'/PartnerWithUs/apply'} />
            </Row>
          </section>
        </Col>
      </div>
    </>
  )
}

PartnerWithUsContent.propTypes = {
  state: PropTypes.string,
}

export default PartnerWithUsContent;